export const formatSlugLabel = (value?: string | null): string =>
  (value ?? "")
    .trim()
    .replace(/[_-]+/g, " ")
    .split(/\s+/)
    .filter(Boolean)
    .map((part) => `${part.charAt(0).toUpperCase()}${part.slice(1)}`)
    .join(" ");

export function formatSlugLabels(
  values?: readonly string[] | null,
  format: (value: string) => string = formatSlugLabel
): string[] {
  const seen = new Set<string>();
  return (values ?? []).map(format).filter((label) => {
    const key = label.trim().toLowerCase();
    if (!key || seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}

export function formatEducationBusinessType(
  profile: {
    businessTypeSlug?: string | null;
    businessSubtypeSlug?: string | null;
    businessSubtypeSlugs?: readonly string[] | null;
  },
  fallback = "Education Provider"
): string {
  const typeLabel = formatSlugLabel(profile.businessTypeSlug);
  const subtypeLabels = formatSlugLabels([
    ...(profile.businessSubtypeSlug ? [profile.businessSubtypeSlug] : []),
    ...(profile.businessSubtypeSlugs ?? []),
  ]).filter((label) => label.toLowerCase() !== typeLabel.toLowerCase());

  if (!typeLabel) return subtypeLabels.join(", ") || fallback;
  if (!subtypeLabels.length) return typeLabel;
  if (subtypeLabels.length === 1 && subtypeLabels[0].toLowerCase().startsWith(`${typeLabel.toLowerCase()} `)) {
    return subtypeLabels[0];
  }
  return `${typeLabel} - ${subtypeLabels.join(", ")}`;
}
